/**
 * Controller for a group list of task triggers
 * @author Ryan Gladstone
 */

function GroupTaskTriggersController(
  $scope,
  $log,
  $stateParams,
  $translate,
  groupsService,
  taskTriggersService,
  layoutService,
  toastWrapperService,
  analyticsService,
  navigationService
) {
  navigationService.navigateGroup('groups.group.task-triggers');

  $scope.alerts = [];

  function resetAlerts() {
    $scope.alerts = [];
  }

  $scope.loadMore = {
    eligible: false,
    page: 0,
    resultsPerPage: 20
  };

  groupsService.getGroup($stateParams.groupId)
    .then((data) => {
      $scope.group = data;
      $scope.newGroupName = data.name;

      $scope.getTriggers();
    }, (response) => {
      $log.error('GroupTaskTriggersController groupsService.getGroup() error', response.error || response);
      toastWrapperService.createToast($translate.instant('ERROR_GETTING_GROUP', { id: $stateParams.groupId }), 'danger');
    });

  $scope.delete = (triggerId) => {
    taskTriggersService.deleteTrigger(triggerId)
      .then(
        () => {
          toastWrapperService.createToast($translate.instant('TRIGGER_DELETED'), 'success');
          _.remove($scope.triggers, trig => trig.id === triggerId);
          analyticsService.trackEvent('Task triggger management', 'Task triggger deleted');
        },
        (response) => {
          $log.error('GroupTaskTriggersController  taskTriggersService.deleteTrigger() error', response.error || response);
          toastWrapperService.createToast($translate.instant('TASK_TRIGGER_UPDATE_FAILED'), 'danger');
        });
  };

  $scope.getTriggers = () => {
    resetAlerts();

    taskTriggersService.getTriggers({
      assignedGroup: $stateParams.groupId,
      page: $scope.loadMore.page
    })
      .then((results) => {
        $scope.loadMore.requestRunning = false;

        if ($scope.loadMore.page > 0) {
          $scope.triggers = _.union($scope.triggers, results);
        } else if (results.length) {
          $scope.triggers = results;

          let notificationText;
          if (results.length > 1) {
            notificationText = `${results.length} ${$translate.instant('TASK_TRIGGERS_FOUND')}`;
          } else {
            notificationText = $translate.instant('ONE_NOTIFICATION_FOUND');
          }

          layoutService.mobileToast('info', notificationText);
        } else {
          $scope.triggers = [];
        }

        $scope.loadMore.eligible = results.length >= $scope.loadMore.resultsPerPage;
      },
      (response) => {
        $log.error('GroupTaskTriggersController taskTriggersService.getTriggers() error:', response.error || response);
        $scope.triggers = [];
        $scope.alerts.push({
          type: 'danger',
          msg: $translate.instant('ERROR_GETTING_TASK_TRIGGERS')
        });
      });
  };

  $scope.loadMoreTriggers = () => {
    if ($scope.loadMore.eligible) {
      $scope.loadMore.page += 1;
      $scope.loadMore.requestRunning = true;
      $scope.getTriggers();
    }
  };
}

const arr = [
  '$scope',
  '$log',
  '$stateParams',
  '$translate',
  'groupsService',
  'taskTriggersService',
  'layoutService',
  'toastWrapperService',
  'analyticsService',
  'navigationService',
  GroupTaskTriggersController
];

module.exports = (ngModule) => {
  ngModule.controller('GroupTaskTriggersController', arr);
};
